import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axios';

const initialState = {
	logs: {
		loading: false,
		logsList: null,
		total: 0,
		detailedLogs: null,
		detailedLogsTotal: 0,
		logDetails: null,
	},
};

export const getAllLogsByCriteria = createAsyncThunk('logs/getAllLogsByCriteria', async (data) => {
	try {
		const response = await axiosInstance.patch(`/audit-logs`, data);
		return response.data;
	} catch (error) {
		const customError = {
			name: 'Custom axios error',
			message: error.response.data.message,
		};
		throw customError;
	}
});

export const getLogDetails = createAsyncThunk('logs/getLogDetails', async (data) => {
	try {
		console.log("entity from getLogDetails", data);
		const response = await axiosInstance.get(`/log-details/?id=${data.id}&className=${data.entity}`);
		return response.data;
	} catch (error) {
		const customError = {
			name: 'Custom axios error',
			message: error.response.data.message,
		};
		throw customError;
	}
});

export const getAllLogsByCriteriaPaged = createAsyncThunk(
	'logs/getAllLogsByCriteriaPaged',
	async ({ data, page = 0, size = 20, sortBy = 'created', sortDirection = 'DESC' }) => {
		try {
			const response = await axiosInstance.patch(
				`/audit-logs/paged?page=${page}&size=${size}&sortBy=${sortBy}&sortDirection=${sortDirection}`,
				{ ...data },
			);
			return response.data;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response.data.message,
			};
			throw customError;
		}
	},
);
export const getDetailedLogsByCriteriaPaged = createAsyncThunk(
	'logs/getDetailedLogsByCriteriaPaged',
	async ({ data, page = 0, size = 20, sortBy = 'created', sortDirection = 'DESC' }) => {
		try {
			const response = await axiosInstance.patch(
				`/detailed-audit-logs/paged?page=${page}&size=${size}&sortBy=${sortBy}&sortDirection=${sortDirection}`,
				{ ...data },
			);
			return response.data;
		} catch (error) {
			const customError = {
				name: 'Custom axios error',
				message: error.response.data.message,
			};
			throw customError;
		}
	},
);

export const logsSlice = createSlice({
	name: 'logs',
	initialState,
	reducers: {},
	extraReducers: {
		[getLogDetails.fulfilled]: (state, action) => {
			state.logs.logDetails = action.payload;
		},
		[getLogDetails.rejected]: (state) => {
			state.logs.logDetails = null;
		},
		[getAllLogsByCriteria.pending]: (state) => {
			state.logs.loading = true;
		},
		[getAllLogsByCriteria.rejected]: (state) => {
			state.logs.loading = false;
		},
		[getAllLogsByCriteria.fulfilled]: (state, action) => {
			state.logs.loading = false;
			state.logs.logsList = Object.values(action.payload);
		},
		[getAllLogsByCriteriaPaged.pending]: (state) => {
			state.logs.loading = true;
		},
		[getAllLogsByCriteriaPaged.rejected]: (state) => {
			state.logs.loading = false;
		},
		[getAllLogsByCriteriaPaged.fulfilled]: (state, action) => {
			state.logs.loading = false;
			state.logs.logsList = action.payload.content;
			state.logs.total = action.payload.totalElements;
		},
		[getDetailedLogsByCriteriaPaged.pending]: (state) => {
			state.logs.loading = true;
		},
		[getDetailedLogsByCriteriaPaged.rejected]: (state) => {
			state.logs.loading = false;
		},
		[getDetailedLogsByCriteriaPaged.fulfilled]: (state, action) => {
			state.logs.loading = false;
			state.logs.detailedLogs = action.payload.content;
			state.logs.detailedLogsTotal = action.payload.totalElements;
		},
	},
});

export default logsSlice.reducer;
